<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-toolbar text color="white">
        <v-toolbar-title>Usuarios</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="brown lighten-1 mx-1" fab small dark @click.native="listar()">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn class="blue mx-1" fab small dark @click.native="print()">
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn class="deep-orange darken-3 mx-1" fab small dark @click.native="abrirNuevoUsuario">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="usuarios"
        :items-per-page="50"
        sort-by="cliente.codigo"
        :search="filtros.otros"
        item-key="_id"
        class="elevation-1"
        :footer-props="{
                            itemsPerPageOptions: [15,50,100,-1]
                        }"
      >
        <template v-slot:top>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs2 sm2 md2>
                <v-text-field
                  v-model="filtros.codigo_cliente"
                  type="number"
                  label="Cód. Cliente"
                  min="1"
                  step="1"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 sm8 md8>
                <v-text-field
                  v-model="filtros.otros"
                  append-icon="search"
                  label="Nombre, alias o email"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-icon class="mt-2" @click="limpiarFiltros()" color="red">clear</v-icon>
              </v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn class="green mx-1" fab small dark @click.native="exportarUsuarios2Excel">
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <template v-slot:item.bloqueo="{ item }">
          <template v-if="item.bloqueado">
            <v-icon small @click="activar(item)">lock</v-icon>
          </template>
          <template v-else>
            <v-icon small @click="desactivar(item)">lock_open</v-icon>
          </template>
        </template>
        <template v-slot:item.accion="{ item }">
          <v-icon small class="mr-2" @click="editarItem(item)">edit</v-icon>
          <v-icon small class="mr-2" @click="eliminarItem(item)">delete</v-icon>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="usuario.cod_cliente"
                    label="Cód. Cli"
                    type="Number"
                    min="1"
                    step="1"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm9 md9>
                  <v-select
                    v-model="usuario.rol"
                    :items="roles"
                    label="*Rol"
                    :readonly="eliminando"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm7 md7>
                  <v-text-field v-model="usuario.nombre" label="*Nombre" :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 md5>
                  <v-text-field v-model="usuario.alias" label="Alias" :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field v-model="usuario.email" label="*Email" :readonly="eliminando"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    type="password"
                    v-model="usuario.password"
                    label="*Password"
                    :readonly="eliminando"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 v-show="!!validaMensaje.length">
                  <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" @click="cerrar">Cancelar</v-btn>
            <v-btn v-if="creando" color="primary darken-1" @click="insertar">Insertar</v-btn>
            <v-btn v-else-if="editando" color="primary darken-1" @click="actualizar">Actualizar</v-btn>
            <v-btn v-else color="primary darken-1" @click="eliminar">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import XLSX from "xlsx";

const CREANDO = 1;
const EDITANDO = 2;
const ELIMINANDO = 3;

export default {
  data() {
    return {
      dialog: false,
      filtros: {
        codigo_cliente: "",
        otros: ""
      },
      usuarios: [],
      headers: [
        {
          text: "Bloqueo",
          value: "bloqueo",
          align: "center",
          sortable: false,
          filterable: false
        },
        {
          text: "Cód. Cliente",
          value: "cliente.codigo",
          align: "center",
          sortable: true,
          filter: value => {
            if (!this.filtros.codigo_cliente) {
              return true;
            }
            return value == parseInt(this.filtros.codigo_cliente);
          }
        },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Rol", value: "rol", sortable: true, filterable: false },
        { text: "Alias", value: "alias", sortable: true },
        { text: "Email", value: "email", sortable: true },
        { text: "Acciones", value: "accion", align: "center", sortable: false }
      ],
      usuario: {
        _id: "",
        cod_cliente: "",
        nombre: "",
        rol: "",
        alias: "",
        email: "",
        password: "",
        creacion: ""
      },
      validaMensaje: [],
      accion: CREANDO
    };
  },
  computed: {
    roles() {
      if (this.usuario.cod_cliente) {
        return ["ClienteAlmacen"];
      } else {
        return ["Administrador", "Almacenero"];
      }
    },
    formTitle() {
      console.log(
        "formTitle this.creando",
        this.creando
          ? "Nuevo registro"
          : this.eliminando
          ? "Eliminar registro"
          : "Editar registro"
      );
      switch (this.accion) {
        case CREANDO:
          return "Nuevo registro";
        case EDITANDO:
          return "Editar registro";
        case ELIMINANDO:
          return "Eliminar registro";
      }
      console.log("No coge el switch");
      return this.creando
        ? "Nuevo registro"
        : this.eliminando
        ? "Eliminar registro"
        : "Editar registro";
    },
    creando() {
      console.log("creando this.accion", this.accion);
      console.log("CREANDO", CREANDO);
      return this.accion == CREANDO;
    },
    editando() {
      console.log("editando this.accion", this.accion);
      console.log("EDITANDO", EDITANDO);
      return this.accion == EDITANDO;
    },
    eliminando() {
      console.log("eliminando this.accion", this.accion);
      console.log("ELIMINANDO", ELIMINANDO);
      return this.accion == ELIMINANDO;
    }
  },
  watch: {
    dialog(val) {
      val || this.cerrar();
    },
    validaMensaje(val) {
      console.log("watch validaMensaje", val);
      if (val.length > 0 && !this.dialog) {
        this.$alert(val[0]);
      }
    }
  },
  created() {
    this.listar();
  },
  methods: {
    print() {
      window.print();
    },
    limpiarFiltros() {
      console.log("limpiarFiltros");
      this.filtros.codigo_cliente = "";
      this.filtros.otros = "";
    },
    getDatosAdicionales(item) {
      console.log("getDatosAdicionales", item);
      let creado_el = new Date(item.creacion);
      console.log("creado_el", creado_el);
      let datos =
        "Creado el " +
        creado_el.getFullYear() +
        "/" +
        (creado_el.getMonth() + 1) +
        "/" +
        (creado_el.getDay() + 1);
      if (item.cliente) {
        datos += ". Empresa: " + item.cliente.nombre_comercial;
      }
      return datos;
    },
    listar() {
      this.search = "";
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("usuario/list", configuracion)
        .then(function(response) {
          me.validaMensaje = [];
          me.usuarios = response.data;
          console.log("me.usuarios", me.usuarios);
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    limpiar() {
      this.usuario = {
        _id: "",
        cod_cliente: "",
        nombre: "",
        rol: "",
        alias: "",
        email: "",
        password: "",
        creacion: ""
      };
      this.validaMensaje = [];
      this.accion = CREANDO;
    },
    esValido() {
      this.validaMensaje = [];
      console.log("this.rol", this.rol);
      if (!this.usuario.rol) {
        this.validaMensaje.push("Seleccione un rol.");
      }
      if (!this.usuario.nombre) {
        this.validaMensaje.push(
          "Nombre del usuario (texto entre 1-64 caracteres)"
        );
      }
      if (!this.usuario.email) {
        this.validaMensaje.push(
          "Email del usuario (formato de dirección de email de máx. 200 caracteres)"
        );
      }
      if (!this.usuario.password) {
        this.validaMensaje.push("Password del usuario (mín. 6 caracteres)");
      }
      return this.validaMensaje.length == 0;
    },
    abrirNuevoUsuario() {
      this.validaMensaje = [];
      this.dialog = true;
    },
    editarItem(item) {
      console.log("editar", item);
      this.usuario._id = item._id;
      if (item.cliente) {
        this.usuario.cod_cliente = item.cliente.codigo;
      }
      this.usuario.rol = item.rol;
      this.usuario.nombre = item.nombre;
      this.usuario.alias = item.alias;
      this.usuario.email = item.email;
      this.usuario.password = item.password;
      this.validaMensaje = [];
      this.dialog = true;
      this.accion = EDITANDO;
    },
    eliminarItem(item) {
      this.editarItem(item);
      this.accion = ELIMINANDO;
    },
    insertar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .post(
          "usuario/add",
          {
            rol: this.usuario.rol,
            cod_cliente: this.usuario.cod_cliente,
            nombre: this.usuario.nombre,
            alias: this.usuario.alias,
            email: this.usuario.email,
            password: this.usuario.password
          },
          configuracion
        )
        .then(function(response) {
          console.log("response", response);
          me.limpiar();
          me.cerrar();
          me.listar();
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    actualizar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (!this.esValido()) {
        return;
      }
      axios
        .put(
          "usuario/update",
          {
            _id: this.usuario._id,
            cod_cliente: this.usuario.cod_cliente,
            rol: this.usuario.rol,
            nombre: this.usuario.nombre,
            alias: this.usuario.alias,
            email: this.usuario.email,
            password: this.usuario.password
          },
          configuracion
        )
        .then(function(response) {
          me.limpiar();
          me.cerrar();
          me.listar();
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    eliminar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      console.log("me.usuario._id", me.usuario._id);
      axios
        .delete("usuario/remove/", {
          data: { _id: me.usuario._id },
          headers: header
        })
        .then(function(response) {
          me.limpiar();
          me.cerrar();
          me.listar();
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    activar(item) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("usuario/activate", { _id: item._id }, configuracion)
        .then(function(response) {
          me.validaMensaje = [];
          me.listar();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    desactivar(item) {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("usuario/deactivate", { _id: item._id }, configuracion)
        .then(function(response) {
          me.validaMensaje = [];
          me.listar();
        })
        .catch(function(error) {
          console.log("Error", error);
          let msj_error = me.$store.state.mensajes.error500;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msj_error = error.response.data.message;
          }
          me.validaMensaje = [];
          me.validaMensaje.push(msj_error);
        });
    },
    exportarUsuarios2Excel() {
      console.log("exportarUsuarios2Excel");
      try {
        let usuarios = [];
        this.usuarios.forEach(u => {
          usuarios.push({
            "Cód. Cliente": u.cliente ? u.cliente.codigo : "",
            Rol: u.rol,
            Nombre: u.nombre,
            Alias: u.alias,
            Email: u.email,
            Bloqueado: u.bloqueado ? "Sí" : "No"
          });
        });
        let worksheet = XLSX.utils.json_to_sheet(usuarios);
        let new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "usuarios");
        XLSX.writeFile(new_workbook, "usuarios.xlsx");
      } catch (error) {
        console.error("export error", error);
      }
    },
    cerrar() {
      this.dialog = false;
      this.limpiar();
    }
  }
};
</script>


<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>